export const getTrainingStatusClass = (status) => {
    switch (status) {
        case "open":
            return "badge bg-light";
        case "approved":
        case "completed":
            return "badge bg-success";
        case "todo":
            return "badge bg-secondary";
        case "approval_manager":
        case "approval_hr":
        case "approval_hse":
        case "in_review":
        case "enrollment_pending":
        case "pending":
            return "badge bg-warning";
        case "feedback":
        case "revision":
        case "enrolled":
            return "badge bg-info";
        case "rejected":
            return "badge bg-danger";
        default:
            return "badge bg-secondary";
    }
}